import app, { appError } from "@/common/plugins/vueInstance";
import router from "./router";
import store from "./store";
import KeyCloak from "@/common/module/keyCloak";
import "@/common/plugins";

(async () => {
  const verifyAuth = await KeyCloak.verifyAuth();

  if (verifyAuth === true) {
    router.beforeEach(KeyCloak.hookBeforeEnterPage);
    router.afterEach(KeyCloak.clearQueryParameters);
    KeyCloak.postMessageToken();

    app.use(store);
    app.use(router);
    app.mount("#app");
  } else {
    appError.mount("#app");
  }
})();
